import { useCallback, useState } from "react";
import { Dialog } from "components/dialogs/Dialog";
import { NicheSelector } from "components/dialogs/NicheSelector";
import { updateNiches } from "./utils";
import { Roles, useData } from "./hooks";
import { Loader } from "components/UI/Loader";

interface IProps {
  gifId: string;
  role: Roles;
  onClose: () => void;
}

export const EditNichesDialog = ({ gifId, role, onClose }: IProps): JSX.Element => {
  const [selected, setSelected] = useState<string[]>();

  const { gif, niches, isLoading, isError } = useData({ gifId, role });

  const handleChange = useCallback((ids: string[]): void => {
    setSelected(ids);
  }, []);

  const handleSave = useCallback(async () => {
    if (!selected) {
      onClose();
      return;
    }

    await updateNiches(gifId, selected, onClose);
  }, [selected, gifId, onClose]);

  const buttons = () => (
    <button className="button primary" onClick={handleSave}>Save</button>
  );

  return (
    <Dialog
      onClose={onClose}
      title="Change gif niches"
      className="editNichesDialog"
      buttons={buttons()}
    >
      {
        isLoading && <Loader/>
      }

      {
        isError && <div>Could not get niches, please try again.</div>
      }

      {
        !isLoading && (
          <NicheSelector
            niches={niches || []}
            selected={selected || gif?.niches || []}
            onChange={handleChange}
          />
        )
      }
    </Dialog>
  );
};
